import {Component, OnInit} from '@angular/core';
import {Page} from '../../../shared/models/page.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MessageService} from '../../../shared/services/message.service';
import {ActivatedRoute, Router} from '@angular/router';
import {KfConfigurationService} from '../../services/kf-configuration.service';
import {KFConfiguration} from '../../models/kf-configuration.interface';
import {KfConfigurationSearch} from '../../../kf-reporting/models/kf-configuration-search.interface';

const WEEE_SYSTEM = 'WEEESYSTEM';
const COUNTRY = 'COUNTRY';

@Component({
  selector: 'app-kf-configuration',
  templateUrl: './kf-configuration.component.html',
  styleUrls: ['./kf-configuration.component.scss']
})
export class KfConfigurationComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  currentRoute?: string;
  kfConfigurationPage!: Page<KFConfiguration>;
  schemaKind!: string;

  private page: PageRequest = {page: 0, size: 100, sort: 'year', direction: 'desc'};

  constructor(private kfConfigurationService: KfConfigurationService,
              private messageService: MessageService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.currentRoute = router.getCurrentNavigation()?.extractedUrl.toString();
  }


  ngOnInit(): void {
    if (this.currentRoute && this.currentRoute.includes('weeesystem')) {
      this.schemaKind = WEEE_SYSTEM;
    } else {
      this.schemaKind = COUNTRY;
    }
    this.loadKfConfigurations(this.page);
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadKfConfigurations(event: PageRequest): void {
    const search = this.getFiltersFromQueryParams();
    this.kfConfigurationService.searchKfConfigurations(search, event, this.schemaKind).subscribe(
      data => {
        this.kfConfigurationPage = data;
      }
    );
  }

  searchKfConfiguration(event: KfConfigurationSearch): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: this.buildQueryParams(event)});
    this.kfConfigurationService.searchKfConfigurations(event, this.page, this.schemaKind).subscribe(data => {
      this.kfConfigurationPage = data;
    });
  }

  printPdf(event: KFConfiguration): void {
    this.kfConfigurationService
      .printPdf(event.year, this.schemaKind)
      .subscribe(response => {
        const blob = new Blob([response.body], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }

  private buildQueryParams(search: KfConfigurationSearch): any {
    const queryParams = {};

    if (search.startYear) {
      Object.assign(queryParams, {startYear: search.startYear});
    }
    if (search.endYear) {
      Object.assign(queryParams, {endYear: search.endYear});
    }
    if (search.unuKeyName && search.unuKeyName !== '') {
      Object.assign(queryParams, {unuKeyName: search.unuKeyName});
    }
    if (search.kfCategoryName && search.kfCategoryName !== '') {
      Object.assign(queryParams, {kfCategoryName: search.kfCategoryName});
    }
    if (search.collectionStreamName && search.collectionStreamName !== '') {
      Object.assign(queryParams, {collectionStreamName: search.collectionStreamName});
    }
    if (search.launched !== undefined) {
      Object.assign(queryParams, {launched: search.launched});
    }
    if (search.startLaunched && search.startLaunched !== '') {
      Object.assign(queryParams, {startLaunched: search.startLaunched});
    }
    if (search.endLaunched && search.endLaunched !== '') {
      Object.assign(queryParams, {endLaunched: search.endLaunched});
    }
    return queryParams;
  }

  private getFiltersFromQueryParams(): KfConfigurationSearch {
    const search = {} as KfConfigurationSearch;
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.startYear) {
        search.startYear = params.startYear;
      }
      if (params.endYear) {
        search.endYear = params.endYear;
      }
      if (params.unuKeyName) {
        search.unuKeyName = params.unuKeyName;
      }
      if (params.kfCategoryName) {
        search.kfCategoryName = params.kfCategoryName;
      }
      if (params.collectionStreamName) {
        search.collectionStreamName = params.collectionStreamName;
      }
      if (params.launched) {
        search.launched = params.launched;
      }
      if (params.startLaunched) {
        search.startLaunched = params.startLaunched;
      }
      if (params.endLaunched) {
        search.endLaunched = params.endLaunched;
      }
    });
    return search;
  }

}
